import * as React from "react";
import { useMediaDevices } from "@dvrt/web-phone-client";

type InitializedMediaDevicesProps = {
    children: React.ReactNode;
    placeholder?: React.ReactNode;
};

export const InitializedMediaDevices = ({ children, placeholder = null }: InitializedMediaDevicesProps) => {
    const devices = useMediaDevices();

    return <React.Fragment>{devices.initialized ? children : placeholder}</React.Fragment>;
};
